import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import News from '../views/News.vue'
import NewsSingle from '../views/NewsSingle.vue'
import Announcement from '../views/Announcement.vue'
import AnnouncementSingle from '../views/AnnouncementSingle.vue'
import EventPage from '../views/EventPage.vue'
import EventPageSingle from '../views/EventPageSingle.vue'
import Presence from '../views/Presence.vue'
import TatibPage from '../views/TatibPage.vue'
import Login from '../views/Login.vue'
import OtpRequest from '../views/OtpRequest.vue'
import OtpLogin from '../views/OtpLogin.vue'
import LoginToken from '../views/LoginToken.vue'

import store from "../store/index.js"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: { 
            requiresAuth: true, 
            title: "Home",
            isBack: false
        },
    },
    {
        path: '/news',
        name: 'news',
        component: News,
        meta: { 
            requiresAuth: true, 
            title: "Berita",
            isBack: true
        }
    },
    {
        path: '/news/:slug',
        name: 'news.detail',
        component: NewsSingle,
        props: true,
        meta: { 
            requiresAuth: true, 
            title: "Detail Berita" ,
            isBack: true
        }
    },
    {
        path: '/announcement',
        name: 'announcement',
        component: Announcement,
        meta: { 
            requiresAuth: true, 
            title: "Pengumuman",
            isBack: true
        }
    },
    {
        path: '/announcement/:slug',
        name: 'announcement.detail',
        component: AnnouncementSingle,
        meta: { 
            requiresAuth: true, 
            title: "Detail Pengumuman",
            isBack: true
        }
    },
    {
        path: '/event',
        name: 'event',
        component: EventPage,
        meta: { 
            requiresAuth: true, 
            title: "Agenda",
            isBack: true
        }
    },
    {
        path: '/event/:slug',
        name: 'event.detail',
        component: EventPageSingle,
        meta: { 
            requiresAuth: true, 
            title: "Detail Agenda",
            isBack: true
        }
    },
    {
        path: '/presence',
        name: 'presence',
        component: Presence,
        meta: { 
            requiresAuth: true, 
            title: "Presensi",
            isBack: true
        }
    },
    {
        path: '/tatib',
        name: 'tatib',
        component: TatibPage,
        meta: { 
            requiresAuth: true, 
            title: "Tata Tertib",
            isBack: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { 
            title: "Login",
            isBack: false
        }
    },
    {
        path: '/request-otp',
        name: 'request_otp',
        component: OtpRequest,
        meta: { 
            title: "Request OTP",
            isBack: false
        }
    },
    {
        path: '/login-otp',
        name: 'login_otp',
        component: OtpLogin,
        meta: { 
            title: "Login OTP",
        }
    },
    {
        path: '/login-token',
        name: 'login_token',
        component: LoginToken,
        meta: { 
            title: "Login Token",
            isBack: false
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    store.commit("CLEAR_ERRORS")
    if (to.matched.some((record) => record.meta.requiresAuth)) {
       let auth = store.getters.isAuth
       if (!auth) {
          next({ name: "login" })
       } else {
          next()
       }
    } else {
       next()
    }
 })
 
 const DEFAULT_TITLE = 'Parental Digital School'
 router.afterEach(to => {
    Vue.nextTick(() => {
       document.title = `${DEFAULT_TITLE} | ${to.meta.title}` || DEFAULT_TITLE;
    })
 })

export default router